export default __webpack_public_path__ + "static/avatar-ellie-ee7eeff52d20547794fbcb0b69d7d15f.png";